import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ProjectPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
            <h1>Project Details: {id}</h1>
            <button
                onClick={() => navigate('/')}
                style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', marginTop: '20px' }}>
                Back to Home
            </button>
        </div>
    );
};

export default ProjectPage;
